module.exports = __webpack_public_path__ + "media/images/redesign-images/collabs/canva/canva-design-08-dcd4ad7c36023b8c520ebf1445b055ef.jpg";